import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Button, Card, Backdrop, CircularProgress } from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { arSA } from "@mui/material/locale";
import { arSD } from "@mui/x-data-grid/locales"; // For DataGrid localization
import CssBaseline from "@mui/material/CssBaseline";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useGetFinancialPeriodsQuery } from "../../../redux/Slices/financial-periodsApi";
import GenericAddModel from "components/genericAddModel";
import CreateNewPeriodModel from "./CreateNewPeriodModel";

const FinancialPeriods = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentAccount, setCurrentAccount] = useState(null);
  const { data, error, isLoading } = useGetFinancialPeriodsQuery({
    page,
    per_page: pageSize,
  });
  console.log("🚀 ~ FinancialPeriods ~ data:", data);
  const handleEditClick = (account) => {
    setCurrentAccount(account);
    setModalOpen(true);
  };
  const columns = [
    { field: "id", headerName: "المعرف ", flex: 0.5 },
    { field: "name", headerName: "الاسم", flex: 1 },
    { field: "start_date", headerName: "بداية الفترة", flex: 1 },
    { field: "end_date", headerName: "نهاية الفترة", flex: 1 },
    { field: "total_debit", headerName: "إجمالي المدين", flex: 1 },
    { field: "total_credit", headerName: "إجمالي الدائن", flex: 1 },
    {
      field: "is_current",
      headerName: "فترة ",
      flex: 0.5,
      renderCell: (params) => (params.value ? "حالية" : "غير حالية"),
    },
    { field: "created_at", headerName: "تاريخ الإنشاء", flex: 1 },
    {
      feild: "actions",
      headerName: "الاجراءات",
      flex: 1.6,
      renderCell: (params) => (
        <>
          <Button onClick={() => handleEditClick(params.row)} sx={{color:"text.main"}}>
            <VisibilityIcon />
          </Button>
          <Button onClick={() => handleEditClick(params.row)} sx={{color:"text.main"}}>
            <EditIcon />
          </Button>
          <Button onClick={() => handleEditClick(params.row)} sx={{color:"text.main"}}>
            <DeleteIcon />
          </Button>
        </>
      ),
    },
  ];

  const rows = data?.data || [];

  const handlePageChange = (newPage) => {
    setPage(newPage + 1); // DataGrid page is 0-indexed
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(1);
  };

  if (isLoading) return <Typography>جاري التحميل...</Typography>;
  if (error) return <Typography>حدث خطأ: {error.message}</Typography>;

  return (
    <>
      <Backdrop open={isLoading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <GenericAddModel open={modalOpen} onClose={() => setModalOpen(false)}>
        <CreateNewPeriodModel
          onSuccess={() => setModalOpen(false)}
          onClose={() => setModalOpen(false)}
        />
      </GenericAddModel>
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              الفترات المالية
            </MDTypography>
            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              إنشاء فترة مالية
            </MDButton>
          </MDBox>
          <CssBaseline />
          <Box sx={{ height: "80vh", width: "100%", padding: 2, dir: "rtl",  }}>
            <DataGrid
              rows={rows}
              columns={columns}
                       sx={{
    color:"text.main",
    // 1. General Grid Background
    bgcolor: "inherit", // Change this to your desired grid background color
    border: "none",
    borderTop: "none",
    // 2. Customizing the Header Background
    '& .MuiDataGrid-columnHeaders': {
      bgcolor: "#f5f5f5", // Change this to your desired header color
      color:"text.main",
      borderBottom: "none !important ",
      border:"none !important",
     // Optional: Adds a separator below headers
    },
    // Removing default focus outlines (from your original code)
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
      outlineOffset: 0,
    },
    
    // Removing the default cell border if you want a cleaner "card" look
    '& .MuiDataGrid-cell': {
      borderBottom: 'none !important',
      border:"none !important", 
      color:"text.main",
      display:"flex",
      
      alignItems:"center",
    },
    "& .MuiToolbar-root-MuiTablePagination-toolbar": {
      color:"text.main",
    },
    "& .MuiDataGrid-footerContainer": {
      color:"text.main",
    },
    "& ..MuiDataGrid-withBorderColor": {
     borderColor:"text.border",
    },
    "& .MuiTablePagination-root":{
      color:"text.main",
    },
    "& .MuiButtonBase-root-MuiIconButton-root":{
      color:"text.main",
    },
    "& .MuiButtonBase-root-MuiIconButton-root.Mui-disabled":{
      color:"text.border",
    },
   
    
    
  }}
              getRowId={(row) => row.id}
              paginationMode="server"
              rowCount={data?.pagination?.total || 0}
              pageSizeOptions={[10, 20, 50]}
              paginationModel={{ page: page - 1, pageSize }}
              onPaginationModelChange={(model) => {
                handlePageChange(model.page);
                handlePageSizeChange(model.pageSize);
              }}
              localeText={arSD.components.MuiDataGrid.defaultProps.localeText}
              disableRowSelectionOnClick
            />
          </Box>
        </Card>
      </MDBox>
    </>
  );
};

export default FinancialPeriods;
